import { HttpHeaders } from '@angular/common/http';
import { IUserProfile, ITabItemView, IToolBar, IApplicationInfo } from 'gadoe-framework';
import { IGridPagination } from './models/common';
// import { IApplicationInfo } from '../framework/shared/models/applicationinfo.model';

export class Config {
  static appSettings: any;
  static ROOT_URL: '';
  static fiscalYear;
  static fiscalYearConfigID;
  static systemID: '';
  static applicationInfo: IApplicationInfo = null;
  static userProfile: IUserProfile = null;
  static httpHeaders = new HttpHeaders().set('Accept', 'application/json')
  .set('Content-Type', 'application/json').set('Access-Control-Allow-Origin', '*') ;
  static fileServerUploadUrl: '';
  static fileServerDownLoadUrl: '';
  static fileServerRootPath: '';
  static selectedTabMenuItem: ITabItemView;
  static selectedTab: number;
  static typeCode: string;
  static menuType: number;
  static StatusID: number;
  static checkPublish: boolean;
  static gridPagination: IGridPagination = {
    buttonCount: 5,
    info: true,
    type: 'numeric',
    pageSizes: false,
    previousNext: true,
    gridPageSize: 50
  };

}
